document.addEventListener('DOMContentLoaded', () => {
  // Disable on desktop
  if (window.innerWidth >= 768) return;

  // --- Element refs ---
  const drawer = document.getElementById('offerDrawer');
  if (!drawer) return;

  const addToCartBtn = document.querySelector('[id^="ProductSubmitButton-"]');
  const closeDrawer = drawer.querySelector('.drawer-close');
  const overlay = drawer.querySelector('.drawer-overlay');
  const drawerAddBtn = document.getElementById('drawerAddToCart');
  const offerCheckboxes = drawer.querySelectorAll('.select-offer');
  const offerText = document.querySelector('.offer-text');
  const copyIcon = document.querySelector('.offer-text-wrap .copy');
  const offerTextwrap = document.querySelector('.offer-text-wrap');
  const upsellProducts = drawer.querySelectorAll('.upsell-prd');

  // --- Click anywhere on upsell product to toggle its checkbox ---
  upsellProducts.forEach(prd => {
    prd.addEventListener('click', e => {
      if (e.target.matches('.select-offer')) return;
      const checkbox = prd.querySelector('.select-offer');
      if (!checkbox) return;
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // --- Update offer text, coupon, and data attributes ---
  function updateOfferText() {
    const selected = [...offerCheckboxes].filter(cb => cb.checked).length;

    let coupon = '';
    let offer = '';

    switch (selected) {
      case 1:
        coupon = window.offerData?.coupan_code_1 || '';
        offer = window.offerData?.offer_text_1 || '';
        break;
      case 2:
        coupon = window.offerData?.coupan_code_2 || '';
        offer = window.offerData?.offer_text_2 || '';
        break;
      case 3:
        coupon = window.offerData?.coupan_code_3 || '';
        offer = window.offerData?.offer_text_3 || '';
        break;
      default:
        offerText.textContent = '';
        offerText.classList.remove('active');
        copyIcon.style.display = 'none';
        offerTextwrap.style.display = 'none';
        drawerAddBtn.textContent = 'GO TO CART';
        return;
    }

    offerText.textContent = offer;
    offerText.classList.add('active');
    offerTextwrap.style.display = 'flex';
    drawerAddBtn.textContent = 'ADD TO CART';

    if (coupon && coupon.trim() !== '') {
      copyIcon.setAttribute('data-coupans', coupon);
      copyIcon.style.display = 'inline-flex';
    } else {
      copyIcon.style.display = 'none';
    }

    // Collect selected upsell product names
    const selectedNames = [...offerCheckboxes]
      .filter(cb => cb.checked)
      .map(cb => cb.closest('.drawer-product')?.querySelector('.details p')?.textContent?.trim() || '')
      .filter(Boolean)
      .join(', ');

    closeDrawer.setAttribute('data-upsellproducts', selectedNames || '');
    drawerAddBtn.setAttribute('data-upsellproducts', selectedNames || '');
  }

  offerCheckboxes.forEach(cb => cb.addEventListener('change', updateOfferText));

  // --- Copy coupon ---
  copyIcon.addEventListener('click', () => {
    const coupon = copyIcon.getAttribute('data-coupans');
    if (!coupon) return;
    navigator.clipboard.writeText(coupon).then(() => {
      const originalHTML = copyIcon.innerHTML;
      copyIcon.innerHTML = 'Copied!';
      setTimeout(() => {
        copyIcon.innerHTML = originalHTML;
      }, 1000);
    }).catch(err => console.error('Clipboard copy failed:', err));
  });

  // --- Handle upsell button click ---
  drawerAddBtn.addEventListener('click', () => {
    const selectedIds = [...offerCheckboxes]
      .filter(cb => cb.checked)
      .map(cb => cb.closest('.drawer-product').dataset.productId);

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cart) return;

    if (selectedIds.length === 0) {
      drawer.classList.remove('active');
      cart.classList.add('active');
      return;
    }

    const items = selectedIds.map(id => ({ id, quantity: 1 }));
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items,
        sections: cart.getSectionsToRender?.().map(s => s.id),
        sections_url: window.location.pathname
      })
    })
      .then(res => res.json())
      .then(data => {
        drawer.classList.remove('active');
        if (cart.renderContents) {
          cart.renderContents(data);
          cart.classList.remove('is-empty');
          cart.classList.add('active');
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(err => console.error('Error adding upsell:', err));
  });

  // --- Drawer close handlers ---
  closeDrawer.addEventListener('click', () => drawer.classList.remove('active'));
  overlay.addEventListener('click', () => drawer.classList.remove('active'));
});
